module.exports = __webpack_public_path__ + "img/membercard-orange.437ac305.svg";